import { Getters } from "vuex-smart-module";
import AuthState from "./state";
import { ITokenStatus } from "./models";

export default class AuthGetters extends Getters<AuthState> {
  // You can declare both getter properties or methods
  get isAuthenticated(): boolean {
    // Getters instance has 'state' property
    return this.state.status === "success";
  }
  get authStatus(): string {
    return this.state.status;
  }
  get authError(): string {
    return this.state.authError;
  }
  get tokenError(): string {
    return this.state.tokenError;
  }
  get isConfirmed(): boolean {
    return this.state.isConfirmed;
  }
  get csrfCookieEnabled(): boolean {
    return this.state.csrfTokenEnabled;
  }
  get tokenSerial(): number {
    return this.state.tokenStatus.serial_number || 0;
  }
  get tokenStatus(): ITokenStatus {
    return this.state.tokenStatus;
  }
  get tokenBlockedRemainTime() {
    return this.state.tokenStatus.block_time;
  }
  get tokenLoaded() {
    return this.state.tokenLoaded;
  }
}
